import script from "./Accordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=ts"

import "./Accordion.vue?vue&type=style&index=0&id=46dd7b22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46dd7b22"]])

export default __exports__